import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

const DoctorKey = 'employeeId'

const DeptId = 'depyId'

const DeptName = 'deptName'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getDoctorId() {
  return Cookies.get(DoctorKey)
}

export function setDoctorId(employeeId) {
  return Cookies.set(DoctorKey, employeeId)
}

export function removeDoctorId() {
  return Cookies.remove(DoctorKey)
}

export function getDeptId() {
  return Cookies.get(DeptId)
}

export function setDeptId(deptId) {
  return Cookies.set(DeptId, deptId)
}

export function removeDeptId() {
  return Cookies.remove(DeptId)
}

export function getDeptName() {
  return Cookies.get(DeptName)
}

export function setDeptName(deptName) {
  return Cookies.set(DeptName, deptName)
}

export function removeDeptName() {
  return Cookies.remove(DeptName)
}


